import React, { lazy, Suspense } from "react";
import { Container } from "react-bootstrap";
import { m } from "framer-motion";

const BentoGrid = lazy(() =>
  import("../../BentoGrid").then((module) => ({ default: module.BentoGrid }))
);
const BentoGridItem = lazy(() =>
  import("../../BentoGrid").then((module) => ({ default: module.BentoGridItem }))
);

const shouldReduceMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const fadeInWhenVisible = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, margin: "100px" },
  transition: { duration: shouldReduceMotion ? 0.1 : 0.2, ease: "easeOut" },
};

const renderHeader = (item) => {
  if (item.statistic) {
    return (
      <div className='!p-0 flex-1 w-full h-full min-h-[6rem] rounded-md flex items-center justify-center text-white flex-col bento-campaign-number py-auto relative'>
        <div
          className='absolute inset-0 rounded-md'
          style={{
            background:
              "radial-gradient(ellipse at top left, #241025 40%, transparent 70%), radial-gradient(circle at bottom right, #1C0C1D 30%, #241025 40%)",
            zIndex: 0,
          }}
        ></div>
        <div className='absolute inset-0 opacity-40 mix-blend-soft-light pointer-events-none'>
          <div className='h-full w-full bg-noise'></div>
        </div>
        <div className='flex flex-col items-center justify-center gap-y-1 px-6 text-center'>
          <span className='text-[96px] lg:text-[80px] md:text-[52px] font-bold mb-1 relative z-10'>
            {item.statistic.number}
          </span>
          <span className='text-lg relative z-10 leading-8 md:text-md'>
            {item.statistic.label}
          </span>
        </div>
      </div>
    );
  }
  return (
    <div className='flex flex-1 w-full h-full min-h-[6rem] rounded-md overflow-hidden'>
      <img
        src={item.image}
        alt={item.alt}
        className='w-full h-full object-cover'
        loading='lazy'
        decoding='async'
      />
    </div>
  );
};

const BentoFeatureGrid = ({ bento }) => (
  <m.section
    id='inaq-marketing-services'
    className='pt-24 sm:py-20 xs:py-16 px-6 md:px-4 sm:px-5'
    style={{ contentVisibility: "auto", containIntrinsicSize: "0 500px" }}
    {...fadeInWhenVisible}
  >
    <Container>
      <div className='mx-auto text-center mb-16 sm:mb-12 xs:mb-10'>
        <h1 className='font-["Oxanium"] text-center sm:text-5xl lg:text-6xl font-bold !pr-0 mb-6 !text-inaqgold relative'>
          {bento.headline}
        </h1>
        <h2 className='mt-2 text-3xl font-normal tracking-tight !text-inaqpurple sm:text-2xl xs:text-xl'>
          {bento.subHeadline}
        </h2>
        <p className='mt-6 text-base leading-7 text-gray-500 max-w-3xl mx-auto xs:text-sm'>
          {bento.intro}
        </p>
      </div>
      <Suspense fallback={<div className='h-64 w-full bg-gray-100 animate-pulse'></div>}>
        <BentoGrid className='max-w-6xl mx-auto'>
          {bento.items.map((item, i) => (
            <BentoGridItem
              key={i}
              title={item.title}
              description={item.description}
              header={renderHeader(item)}
              className={item.className}
            />
          ))}
        </BentoGrid>
      </Suspense>
    </Container>
  </m.section>
);

export default BentoFeatureGrid;
